// The Scholars' bench, drawn. Same idea as the Hall's card emblems and the
// city's buildings: constant line art in a 24x24 box, stroked in
// currentColor. Nothing to load, and a principle looks the same in the
// notebook, in a flask and on a chip.
//
// Eight principles, because a deduction game needs the things you are
// deducing ABOUT to be objects you recognise at a glance.

export const PRINCIPLE_ART = {
  fire: '<path d="M12 2.5c.8 5.2-3 6.4-3 10a3 3 0 0 0 1.6 2.7c-.4-2.6 1-4 2.4-5.2 0 3.6 4 4.3 4 8.1 0 2.8-2.7 4.4-5 4.4s-5-1.9-5-5c0-5 5-6.2 5-15Z"/>',
  water: '<path d="M12 21c3.3 0 6-2.6 6-5.9C18 11 12 3 12 3S6 11 6 15.1C6 18.4 8.7 21 12 21Z"/>',
  stone: '<path d="M4 15.5 8 6.5l7-2.5 5 6.5-2 8.5-9 1Z"/><path d="m8 6.5 3 5.5 4-8M11 12l-7 3.5M11 12l8-1.5M11 12l-2 6.5"/>',
  wind: '<path d="M3 8h9a2.8 2.8 0 1 0-2.8-2.8"/><path d="M3 12.5h12.5a2.8 2.8 0 1 1-2.8 2.8"/><path d="M3 17h6"/>',
  growth: '<path d="M12 21V9"/><path d="M12 12C8.7 12 6.5 9.8 6.5 6.5 9.8 6.5 12 8.7 12 12Z"/><path d="M12 11c0-3.3 2.2-5.5 5.5-5.5C17.5 8.8 15.3 11 12 11Z"/><path d="M7.5 21h9"/>',
  metal: '<path d="M6 20h12l-2-3.5H8Z"/><path d="M3.5 16.5h7l-1.6-3.5H5.1ZM13.5 16.5h7l-1.6-3.5h-3.8Z"/><path d="M9 13h6l-1.6-3.5h-2.8Z"/>',
  number: '<path d="M5.5 6v12M10 6v12M14.5 6v12M19 6v12"/><path d="M3.5 17.5 20.5 6.5"/>',
  word: '<path d="M12 3v18"/><path d="m12 8 5-4M12 13 7 9M12 17.5l5-4"/>',
};
export const artForPrinciple = (p) => PRINCIPLE_ART[p] || PRINCIPLE_ART.stone;

// An empty flask: what a slot looks like before a principle is in it.
export const FLASK_ART = '<path d="M9.5 3v6.2L4.9 17A2.4 2.4 0 0 0 7 20.6h10A2.4 2.4 0 0 0 19.1 17L14.5 9.2V3"/><path d="M8.5 3h7"/><path d="M7.2 14.5h9.6"/>';

// The other ways to spend a day.
export const SCHOLAR_ACTION_ART = {
  publish: '<path d="M6 3.5h9l3.5 3.5V17H6Z"/><path d="M9 8h6M9 11h6M9 14h4"/><path d="M15.5 17v4l-2-1.3-2 1.3v-4"/>',
  hint: '<path d="M4 20V10c0-1.5.9-2.5 2-2.5s2 1 2 2.5v10Z"/><path d="M10 20V6c0-1.7 1-3 2.2-3s2.3 1.3 2.3 3v14Z"/><path d="M16.5 20v-7c0-1.3.8-2.2 1.8-2.2s1.7.9 1.7 2.2v7Z"/>',
  study: '<path d="M12 6.5C9.8 4.9 7.2 4.3 4 4.6v13c3.2-.3 5.8.3 8 1.9 2.2-1.6 4.8-2.2 8-1.9v-13c-3.2-.3-5.8.3-8 1.9Z"/><path d="M12 6.5V19"/>',
  ponder: '<path d="M7.8 15A4.2 4.2 0 0 1 8.3 6.6a4.6 4.6 0 0 1 8.5.6A3.6 3.6 0 0 1 16.3 15Z"/><circle cx="7" cy="18.2" r="1.4"/><circle cx="10.8" cy="20.8" r="1"/>',
  // A kiln: a dome with a mouth and a flame in it.
  fire: '<path d="M4 20h16"/><path d="M6 20v-7a6 6 0 0 1 12 0v7"/><path d="M10 20v-3.5a2 2 0 0 1 4 0V20"/><path d="M12 9c1.2 1.1 1.5 2 .9 3-.4.7-1.4.7-1.8 0-.5-.9-.1-1.8.9-3Z"/>',
  make: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4"/><circle cx="12" cy="12" r="3.5"/>',
  'build-monument': '<path d="M5 21h14"/><path d="M8 21V9l4-5 4 5v12"/><path d="M8 13h8M8 17h8"/>',
};
export const artForScholarAction = (id) => SCHOLAR_ACTION_ART[id] || SCHOLAR_ACTION_ART.study;

// The three properties, drawn. A nature is three of these, and the same
// badge appears in the notebook, on a technology's "needs", in the glass
// and in the tour - so "wet" is a picture you recognise, not a word in a
// table. Alchemists draws its alchemicals rather than naming them, which
// is what makes the deduction readable at a glance.
export const ASPECT_ART = {
  heat: {
    // A thermometer, not a flame: the flame is FIRE, an element (playtest 9:
    // "the symbol for fire is the same as the symbol for heat", and at 12px
    // the flame read as the cold drop).
    true: '<path d="M6.6 2.6a1.4 1.4 0 0 1 2.8 0v6.9a2.9 2.9 0 1 1-2.8 0Z"/><path d="M8 5.2v6.4"/><path d="M11.6 3.6h2M11.6 6.2h1.4"/>',
    false: '<path d="M8 1.6v12.8M2.5 4.8l11 6.4M13.5 4.8l-11 6.4"/><path d="M8 4.3 6.4 2.8M8 4.3l1.6-1.5M8 11.7l-1.6 1.5M8 11.7l1.6 1.5"/>',
  },
  moisture: {
    // Waves, not a drop: the drop is WATER, an element (playtest 9).
    true: '<path d="M1.8 4.6c1.6-1.3 3-1.3 4.2 0s2.6 1.3 4.2 0 2.6-1.3 4 0"/><path d="M1.8 8.4c1.6-1.3 3-1.3 4.2 0s2.6 1.3 4.2 0 2.6-1.3 4 0"/><path d="M1.8 12.2c1.6-1.3 3-1.3 4.2 0s2.6 1.3 4.2 0 2.6-1.3 4 0"/>',
    false: '<path d="M1.6 13.6h12.8"/><path d="m5.4 13.6 1.2-3.3-1.4-2 1.6-2.6-1-2.5"/><path d="m10.6 13.6-.9-2.6 1.5-1.9-1.1-2.2"/>',
  },
  weight: {
    true: '<path d="M3.2 13.8h9.6l-1-6.2H4.2Z"/><path d="M6.2 7.6V5.8a1.8 1.8 0 0 1 3.6 0v1.8"/>',
    false: '<path d="M4.2 12.6C3.1 9.2 5.2 4.4 9.6 2.9c1.4 3.6 1.1 8.7-3 10.2-1.3.5-2.4.2-2.4-.5Z"/><path d="M9.2 4.4 4.6 12.2"/><path d="M2.4 14.2 5 11.5"/>',
  },
};
export const artForAspect = (aspect, value) => (ASPECT_ART[aspect] || {})[String(Boolean(value))] || '';
